var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.682 4.864L4 11.22v6.86c0 .37.299.67.667.67l4.669-.012a.668.668 0 00.663-.67v-4.006c0-.37.298-.67.667-.67h2.666c.368 0 .667.3.667.67v4.003a.671.671 0 00.666.672l4.667.013c.369 0 .667-.3.667-.67v-6.864l-7.68-6.352a.506.506 0 00-.637 0zm12.133 4.32L20.332 6.3V.502a.501.501 0 00-.5-.502H17.5c-.276 0-.5.225-.5.502v3.04L13.27.458a1.993 1.993 0 00-2.541 0L.18 9.184a.503.503 0 00-.066.708l1.062 1.297a.5.5 0 00.705.069l9.8-8.11a.506.506 0 01.637 0l9.8 8.11a.498.498 0 00.705-.067l1.062-1.298a.504.504 0 00-.07-.709z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.135be22c3eba84a2ae96729d57e017d2.svg";
export { ForwardRef as ReactComponent };